/** Mirror packages/auth-common token-claims for frontend JWT parsing */
export function extractOrganizationId(payload: Record<string, unknown>): string {
  const direct =
    payload.organizationId ??
    payload.organization_id ??
    payload.org_id ??
    payload.orgId;

  if (typeof direct === 'string' && direct.trim()) {
    return direct.trim();
  }

  const attrs = payload.attributes as Record<string, unknown> | undefined;
  if (attrs) {
    const fromAttrs = attrs.organizationId ?? attrs.org_id;
    if (Array.isArray(fromAttrs) && typeof fromAttrs[0] === 'string' && fromAttrs[0].trim()) {
      return fromAttrs[0].trim();
    }
    if (typeof fromAttrs === 'string' && fromAttrs.trim()) {
      return fromAttrs.trim();
    }
  }

  return '';
}
